import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TablePagination from '@material-ui/core/TablePagination';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import PersonAddIcon from '@material-ui/icons/PersonAdd';

import BRFab from '../../common-components/BRFab';

import * as usersSearchFormReducers from '../reducer/usersSearchForm';
import * as systemReducer from '../../system/reducer';

import * as usersSearchFormActions from '../action-mgr/usersSearchForm';
import * as usersActions from '../action-mgr';

import SearchBox from '../../common-components/SearchBox';
import FlexOne from '../../common-components/FlexOne';

import { statusList } from '../constants';
import * as strings from '../../helpers/strings';
import { setTimeout } from 'core-js';
// importing Css
import '../../index.css';

const styles = {
  root: {
    marginBottom: 20
  },
  dnone: {
    display: "none"
  },
  m0: {
    margin: '0px'
  }
}

class UserNamesSearchBox extends Component {

  constructor() {
    super();

    this.handleOnSearchChange = this.handleOnSearchChange.bind(this);
    this.handleOnPageChange = this.handleOnPageChange.bind(this);
    this.handleSearchKeyDown = this.handleSearchKeyDown.bind(this);
    this.handleAddClick = this.handleAddClick.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
  }

  componentDidMount() {
    this.handleOnPageChange(null, 0);
  }

  handleOnSearchChange(e) {
    const { setKeyword } = this.props;
    setKeyword(e.target.value);
  }

  handleOnPageChange(event, page) {
    const { pagination, userName, searchUsers, clientSearch, loggedInUser, status, keyword } = this.props;

    if (loggedInUser.role === "system-user" || userName !== "" || status === 2) {
      clientSearch({
        keyword: userName,
        startIndex: 0,
        size: pagination.rowsPerPage,
        status
      })
    } else {
      searchUsers({
        keyword: userName,
        startIndex: page,
        size: pagination.rowsPerPage,
        status
      })
    }

  }

  handleSearchKeyDown(e) {
    const { pagination, searchUsers, keyword, clientSearch, setUserName, status, loggedInUser } = this.props;
    if ("Enter" === e.key) {
      if (loggedInUser.role === "system-user" || keyword !== "" || status === 2) {
        clientSearch({
          keyword: keyword,
          startIndex: pagination.currentPage * pagination.rowsPerPage,
          size: pagination.rowsPerPage,
          status
        });
      } else {
        searchUsers({
          startIndex: pagination.currentPage * pagination.rowsPerPage,
          size: pagination.rowsPerPage,
          status
        });
      }
      setUserName(keyword);
    }
  }

  handleAddClick() {
    const { addNewUser, history } = this.props;
    addNewUser();
    history.push("/users/new");
  }

  handleStatusChange = event => {
    const { keyword, setUserName } = this.props;

    var status = event.target.value;
    this.props.setStatus(status);

    setUserName(keyword);
    setTimeout(() => this.handleOnPageChange(null, 0), 100);
  }

  render() {
    const { keyword, classes, status, pagination } = this.props;

    return (
      <div className={classes.root}>
        <Grid container alignItems="center">
          <Grid item md={3} sm={6} xs={12}>
            <SearchBox
              value={keyword}
              onChange={this.handleOnSearchChange}
              onKeyDown={this.handleSearchKeyDown}
              placeholder={strings.placeholderEnterName}
              fullWidth={true}
            />
          </Grid>
          &nbsp;
          <FormControl variant={strings.txtOutlined}>
            <InputLabel htmlFor={strings.idSelectStatus}>{strings.lblStatus}</InputLabel>
            <Select
              className='userStatusSelection'
              value={status}
              onChange={this.handleStatusChange}
              input={
                <OutlinedInput
                  labelWidth={50}
                  name={strings.idSelectStatus}
                  id={strings.idSelectStatus}
                />
              }
            >
              {statusList.map(statusObj => <MenuItem key={statusObj.value} value={statusObj.value}>{statusObj.name}</MenuItem>)}
            </Select>
          </FormControl>
          <FlexOne />
          <BRFab onClick={this.handleAddClick}><PersonAddIcon /></BRFab>
          <span style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.54)' }}> Total Page: {pagination.currentPage + 1} - {pagination.totalPages} </span>
          <TablePagination
            classes={{
              caption: classes.dnone,
              actions: classes.m0,
            }}
            component="div"
            count={pagination.totalRecord}
            rowsPerPage={pagination.rowsPerPage}
            page={pagination.currentPage}
            backIconButtonProps={{
              'aria-label': strings.lblPreviousPage,
            }}
            nextIconButtonProps={{
              'aria-label': strings.lblNextPage,
            }}
            rowsPerPageOptions={[pagination.rowsPerPage]}
            onChangePage={this.handleOnPageChange}
          />
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  keyword: usersSearchFormReducers.getKeyword(state),
  userName: usersSearchFormReducers.getUserName(state),
  pagination: usersSearchFormReducers.getPagination(state),
  status: usersSearchFormReducers.getStatus(state),

  loggedInUser: systemReducer.getLoggedInUser(state)
});

const mapActionToProps = {
  setKeyword: usersSearchFormActions.setKeyword,
  setStatus: usersSearchFormActions.setStatus,
  setUserName: usersSearchFormActions.setUserName,

  searchUsers: usersActions.search,
  clientSearch: usersActions.clientSearch,

  addNewUser: usersActions.addNewUser,
};

export default connect(mapStateToProps, mapActionToProps)(
  withStyles(styles)(
    withRouter(UserNamesSearchBox)
  )
);